export default __webpack_public_path__ + "static/media/3.2.2afac526.mp4";